import type { PurchasedGalleryListResult } from '../../domain/entities/Order';
import type { OrderRepository } from '../../domain/repositories/OrderRepository';

export class GetPurchasedGalleriesUseCase {
  constructor(private readonly repository: OrderRepository) {}

  async execute(page = 1, perPage = 15, slug?: string): Promise<PurchasedGalleryListResult> {
    return this.repository.getPurchasedGalleries(page, perPage, slug);
  }
}
